import {SHEET_NAME} from '../constants'
import {getLowerCaseColumnTitles} from './utils/get-lower-case-file-columns'
import {getUnregisteredUsers} from './utils/get-unregistered-users'

import {useImportFromFileStore} from '../import-from-file-store'
import {importFile} from './import-file'
import {loadXLSX} from 'yougile-util'

type UseProcessFileRet = {
  processFile: (cb?: () => void, withoutChecking?: boolean) => void
}

export const useProcessFile = (): UseProcessFileRet => {
  const [state, store] = useImportFromFileStore()

  const processFile = (cb?: () => void, withoutChecking?: boolean): void => {
    const worksheet = state.workBook?.Sheets[SHEET_NAME]
    store.setCanStartImport(false)

    loadXLSX(xlsx => {
      try {
        if (!xlsx.utils.sheet_to_json || !worksheet) {
          return
        }
        const tableData = xlsx.utils.sheet_to_json(worksheet, {raw: true})
        if (!tableData) {
          return
        }

        state.columnTitlesMap = getLowerCaseColumnTitles(state.columnTitles)

        if (withoutChecking) {
          importFile(state, store, tableData)
          return
        }

        const unregisteredUsers = getUnregisteredUsers(tableData)
        if (unregisteredUsers.length === 0) {
          importFile(state, store, tableData)
          return
        }

        state.unregisteredUsers = [...new Set(unregisteredUsers)]
        store.setOpen(false)
        state.isErrorPopupOpen = true
      } finally {
        cb?.()
      }
    })
  }

  return {processFile}
}
